export const formatExplanationPart = (part: string, index: number) => {
  if (part.startsWith(`${index + 1}.`)) return part;

  return `${index + 1}. ${part}`;
};
